const STORAGE_KEY = 'ReceitaSolicitada';
const TTL_MS = 2 * 60 * 60 * 1000; // 2 horas

export const setReceitaSolicitada = (item) => {
    try {
        const payload = JSON.stringify({ data: item, timestamp: Date.now() });
        sessionStorage.setItem(STORAGE_KEY, payload);
        // limpa resquício de versões antigas, que gravavam em localStorage sem expiração
        localStorage.removeItem(STORAGE_KEY);
        return !!sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {
        return false;
    }
};

export const getReceitaSolicitada = () => {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return null;

        const parsed = JSON.parse(raw);
        const isExpired = !parsed || typeof parsed.timestamp !== 'number' || (Date.now() - parsed.timestamp) > TTL_MS;
        if (isExpired) {
            sessionStorage.removeItem(STORAGE_KEY);
            return null;
        }

        return parsed.data;
    } catch (e) {
        sessionStorage.removeItem(STORAGE_KEY);
        return null;
    }
};

export const hasReceitaSolicitada = () => getReceitaSolicitada() !== null;

export const clearReceitaSolicitada = () => {
    sessionStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(STORAGE_KEY);
};
